import axios from "axios";

export async function send(dat_a) {
  try {
    // var data = await axios.get("http://localhost:9800");
    // https://easyquizy.onrender.com/
    // var data = await axios.post("http://localhost:9800/users", dat_a);

    // https://quizservice.onrender.com/
    // var data = await axios.post(
    //   "https:easequizzy-two.onrender.com/users",
    //   dat_a
    // );
    var data = await axios.post(
      "https://quizservice.onrender.com/users",
      dat_a
    );

    console.log(data);
  } catch (e) {
    console.log(e.message);
  }
}

export async function res_submit(data){
     try{
       //https:easequizzy-two.onrender.com/result
      //  var data = await axios.post("http://localhost:9800/result", data);
       var data = await axios.post(
         "https://quizservice.onrender.com/result",
         data
       );

       console.log(data);
     }
     catch(e){
      console.log(e.message);
     }
}